// extracted by mini-css-extract-plugin
export default {"component":"WidgetDayDuration_component__VFapA","titleContainer":"WidgetDayDuration_titleContainer__y3pJo","row":"WidgetDayDuration_row__x0-+j"};